import { memo } from 'react';
import isEqual from 'react-fast-compare';
import styled, { css } from 'styled-components';

import { CodeFeatureFlag } from '~/config/code-feature-flags';
import { avalaraCountries } from '~/utilities/constants';
import { useAppContext } from '~/utilities/context/static/AppContext';

const S = {
  PriceTax: styled.span`
    ${({ theme }) => css`
      color: ${theme.colors.content.tertiary};
      font-size: ${theme.font.size[2]};
      font-style: normal;
      font-weight: ${theme.variables.font.weight.regular};
      white-space: nowrap;
      vertical-align: bottom;
    `}
  `,
};

type Props = {
  taxV2: string;
};

const PriceTaxComponent = ({ taxV2 = '' }: Props) => {
  const { siteType, country } = useAppContext();

  const isAvalara = avalaraCountries.includes(country);
  const { displayTax } = CodeFeatureFlag[siteType];

  return (
    <>
      {displayTax && !isAvalara && taxV2 && (
        <S.PriceTax data-testid="summary-price-tax" data-cs-capture="">
          {taxV2}
        </S.PriceTax>
      )}
    </>
  );
};

export const PriceTax = memo(PriceTaxComponent, isEqual);
